import { SET_USER_DATA } from "../constants/Constants";

export const AuthReducer = (state = {}, action) => {
  switch (action.type) {
    case SET_USER_DATA:
      return {
        user: action.payload,
      };
    default:
      return state;
  }
};
